// extracted by mini-css-extract-plugin
export var btn = "QuinaryCard-module--btn--f4b4a";
export var btnWrapper = "QuinaryCard-module--btnWrapper--068d0";
export var contentContainer = "QuinaryCard-module--contentContainer--01cf8";
export var headingContainer = "QuinaryCard-module--headingContainer--f6f0b";
export var headingsContainer = "QuinaryCard-module--headingsContainer--2fa1c";
export var qIcon = "QuinaryCard-module--qIcon--8932c";
export var quinary = "QuinaryCard-module--quinary--21abc";